/* eslint-disable */
import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
function PopFirstClassReport(props) {
  const {open, close} = props;
  const [detailTabIdx, setDetailTabIdx] = useState(0);
  const detailTab = [
    {title: '첫 수업 보고서', value: 0},
    {title: '모니터링 보고서', value: 1}
  ];
  return (
    <Modal open={open} close={close} type="com_input pop_first_class">
      <Tab data={detailTab} tab={detailTabIdx} setTab={setDetailTabIdx} />
      <div className="content_container scroll">
        {detailTabIdx === 0 ? (
          <div className="tab_content">
            <section className="content_box scroll">
              <div className="com_info">
                <p className="name">홍길동104</p>
                <span className="dot" />
                <p className="date">2023.05.20 11:30</p>
              </div>
              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">학생명</span>
                    <span className="cont">
                      <button className="name btn_link">홍길동103 </button>
                      <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                    </span>
                  </div>
                  <div className="info">
                    <span className="tit">연락처</span>
                    <span className="cont">010-1234-134ㆍ부)010-1234-0134ㆍ모)010-1345-3214</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">첫 수업일시</span>
                    <span className="cont">2023, 05, 10ㅣ12:30</span>
                  </div>
                  <div className="info">
                    <span className="tit">다음 수업일시</span>
                    <span className="cont">2023, 05, 10ㅣ12:30</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사320</span>
                  </div>
                  <div className="info">
                    <span className="tit">담임</span>
                    <span className="cont">김담임1324</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">수업 방법</span>
                    <span className="cont">대면</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업 과목</span>
                    <span className="cont">과탐</span>
                  </div>
                  <div className="info">
                    <span className="tit">기수 / 타임</span>
                    <span className="cont">2기 / 2T</span>
                  </div>
                  <div className="info">
                    <span className="tit">이지교재</span>
                    <span className="cont">교재명교재명</span>
                  </div>
                </div>
              </div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="130" />
                  <col width="auto" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>수업 도착시간</th>
                    <td>
                      <div className="com_input_wrap flex_row gap">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">정시도착</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">
                            <span className="txt">지각</span>
                            <select className="select">
                              <option value="10분">10분</option>
                            </select>
                          </label>
                        </div>
                        <input type='text' placeholder='지각 사유 내용 입력' className='input ws'/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>지각시 통화여부</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">통화함</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">통화 안함</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>학생 반응</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우긍정</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로긍정</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">보통</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로부정</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우부정</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>수업이해도</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우잘함</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로잘함</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">보통</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로못함</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우못함</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>등급수준</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">최상위</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">2~3등급</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">3~4등급</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">4~5등급</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">5등급이하</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>학부모 반응</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우긍정</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로긍정</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">보통</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로부정</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우부정</label>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th>수업진행 가능성</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우긍정</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로긍정</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">보통</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로부정</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우부정</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>상담내용</th>
                    <td>
                      <div className="check">
                        <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                        <label htmlFor="chk010">학습계획</label>
                        <input type="checkbox" name="chk" id="chk011" className="com_chk" />
                        <label htmlFor="chk011">공부방법</label>
                        <input type="checkbox" name="chk" id="chk012" className="com_chk" />
                        <label htmlFor="chk012">입시상담</label>
                      </div>
                      <div className="com_input_wrap flex_row">
                        <input type="checkbox" name="chk" id="chk013" className="com_chk" />
                        <label htmlFor="chk013">기타</label>
                        <input type="text" className="input" placeholder="내용 입력" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="130" />
                  <col width="auto" />
                </colgroup>
                <tbody>
                  <tr>
                    <th rowSpan={2}>문제점</th>
                    <td>
                      <div className="com_input_wrap flex_between">
                        <select className="select ws">
                          <option value="회원과 무관한 문제">회원과 무관한 문제</option>
                        </select>
                        <button className="btn_minus_gray"></button>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="border_left">
                      <input type="text" className="input" placeholder="내용 입력" />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="com_btn_wrap bottom">
                <button className="com_btn gray xs">+ 문제점 추가</button>
              </div>
            </section>
            <section className="content_box">
              <div className="detail_tit dot">학습 계획표</div>
              <table className="com_board_list week_list">
                <colgroup>
                  <col width="89" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                </colgroup>
                <thead>
                  <tr>
                    <th>진도및 과제</th>
                    <th>월</th>
                    <th>화</th>
                    <th>수</th>
                    <th>목</th>
                    <th>금</th>
                    <th>토</th>
                    <th>일</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((_, idx) => (
                    <tr key={idx}>
                      <th>{idx + 1}주차</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </div>
        ) : (
          <div className="tab_content">
            <section className="content_box scroll">
              <div className="com_info">
                <p className="name">홍길동104</p>
                <span className="dot" />
                <p className="date">2023.05.20 11:30</p>
              </div>

              <div className="com_board_box">
                <div className="board_item">
                  <div className="info">
                    <span className="tit">학생명</span>
                    <span className="cont">
                      <button className="name btn_link">홍길동103 </button>
                      <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                    </span>
                  </div>
                  <div className="info">
                    <span className="tit">연락처</span>
                    <span className="cont">010-1234-134ㆍ부)010-1234-0134ㆍ모)010-1345-3214</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">첫 수업일시</span>
                    <span className="cont">2023, 05, 10ㅣ12:30</span>
                  </div>
                  <div className="info">
                    <span className="tit">다음 수업일시</span>
                    <span className="cont">2023, 05, 10ㅣ12:30</span>
                  </div>
                  <div className="info">
                    <span className="tit">교사</span>
                    <span className="cont">김교사320</span>
                  </div>
                  <div className="info">
                    <span className="tit">담임</span>
                    <span className="cont">김담임1324</span>
                  </div>
                  <hr className="com_divider" />
                  <div className="info">
                    <span className="tit">수업 방법</span>
                    <span className="cont">대면</span>
                  </div>
                  <div className="info">
                    <span className="tit">수업 과목</span>
                    <span className="cont">과탐</span>
                  </div>
                  <div className="info">
                    <span className="tit">기수 / 타임</span>
                    <span className="cont">2기 / 2T</span>
                  </div>
                  <div className="info">
                    <span className="tit">이지교재</span>
                    <span className="cont">교재명교재명</span>
                  </div>
                </div>
              </div>
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="130" />
                  <col width="auto" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>수업 만족도</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우잘함</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로잘함</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">보통</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">대체로못함</label>
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">매우못함</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>수업 준수</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">준수</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">미준수</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>수업 진행여부</th>
                    <td>
                      <div className="com_input_wrap flex_row">
                        <div className="check">
                          <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                          <label htmlFor="rdo_01">진행</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">보류</label>
                          <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                          <label htmlFor="rdo_02">중단</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="detail_tit dot">회원 요망사항</div>
              <textarea className="textarea"></textarea>
            </section>
            <section className="content_box">
              <div className="detail_tit dot">학습 계획표</div>
              <table className="com_board_list week_list">
                <colgroup>
                  <col width="89" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                  <col width="74" />
                </colgroup>
                <thead>
                  <tr>
                    <th>진도및 과제</th>
                    <th>월</th>
                    <th>화</th>
                    <th>수</th>
                    <th>목</th>
                    <th>금</th>
                    <th>토</th>
                    <th>일</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((_, idx) => (
                    <tr key={idx}>
                      <th>{idx + 1}주차</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          </div>
        )}
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopFirstClassReport;
